import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/components/state/RequirePermission'
import { Equipe } from '@/features/equipe/Equipe'

/** Quem é da equipe, com que papel, e o que cada papel libera. */
export const Route = createFileRoute('/_app/app/config/equipe')({
  component: () => (
    <RequirePermission permission="equipe.manage">
      <Equipe />
    </RequirePermission>
  ),
})
